import React from 'react';
import { Alert } from '@/shared/ui';

const AdditionalAddressInputsNeededAlert: React.FC = () => (
    <Alert variant='infoV2' className="mb-4" label={
        <span className='font-atkinsonHyperlegible text-15 sm:text-16 leading-[137%] text-primary-900'>Please add the apartment, suite, or box number to match to a specific address.</span>
    } />
);

export default AdditionalAddressInputsNeededAlert;